import React from "react";
import { createRoot } from "react-dom/client"; // ✅ UPDATED
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";

import "./style.css";
import Home from "./views/home";
import Welcome from "./views/welcome";
import Cancel from "./views/cancel";
import Success from "./views/success";
import Login from "./views/login";
import ChangePassword from "./views/change-password";
import Dashboard from "./views/dashboard";
import Clients from "./views/clients";
import CrmLite from "./views/crm-lite";
import Scheduler from "./views/scheduler";
import QrCode from "./views/qr-code";
import Commerce from "./views/commerce";
import Support from "./views/support";
import Dispatcher from "./views/dispatcher";
import Analytics from "./views/analytics";
import QrDisplay from "./views/qr-display";
import Tutorial from "./views/tutorial";
import WaBaSetup from "./views/waba-setup";
import PrivacyPolicy from "./views/private-policy";
import NotFound from "./views/not-found";
import "./i18n";

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={Home} exact path="/" />
        <Route component={WaBaSetup} path="/waba-setup" />
        <Route component={Welcome} exact path="/welcome" />
        <Route component={Cancel} exact path="/cancel" />
        <Route component={Success} exact path="/success" />
        <Route component={Login} exact path="/login" />
        <Route component={ChangePassword} exact path="/change-password" />
        <Route component={Dashboard} path="/dashboard" />
        <Route component={Clients} path="/clients" />
        <Route component={CrmLite} path="/crm-lite" />
        <Route component={Scheduler} path="/scheduler" />
        <Route component={QrCode} path="/qr-code" />
        <Route component={Commerce} path="/commerce" />
        <Route component={Support} path="/support" />
        <Route component={Dispatcher} path="/dispatcher" />
        <Route component={Analytics} path="/analytics" />
        <Route component={QrDisplay} path="/qr/:code" />
        <Route component={Tutorial} path="/tutorial" />
        <Route component={WaBaSetup} path="/waba-setup" />
        <Route component={PrivacyPolicy} path="/privacy-policy" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  );
};

// ✅ NEW React 18 rendering
const container = document.getElementById("app");
const root = createRoot(container);

root.render(
    <App />
);